export function findTwoLargestValuesIndex(data: number[]) {
  let max = 0;
  let secondMax = 0;
  let maxIndex = 0;
  let secondMaxIndex = 0;
  data.forEach((element, index) => {
    if (element > max) {
      secondMax = max;
      secondMaxIndex = maxIndex;
      max = element;
      maxIndex = index;
    } else if (element > secondMax) {
      secondMax = element;
      secondMaxIndex = index;
    }
  });
  return [maxIndex, secondMaxIndex];
}
